import { render, staticRenderFns } from "./audiozw.vue?vue&type=template&id=0adda05f&scoped=true&"
import script from "./audiozw.vue?vue&type=script&lang=js&"
export * from "./audiozw.vue?vue&type=script&lang=js&"
import style0 from "./audiozw.vue?vue&type=style&index=0&id=0adda05f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adda05f",
  null
  
)

export default component.exports